const style = (theme) => {
  const output = {
    root: {},
    intro: {
      // display: 'flex',
    },
    pretitle: {
      // width: '29%',
      paddingRight: 20,
      marginBottom: 40,
    },
    text: {
      width: '71%',
    },
    list: {
      marginTop: 60,
      display: 'flex',
      flexWrap: 'wrap',
      // margin: [0, -10],
      justifyContent: 'space-between',
    },
    item: {
      flex: '0 0 calc(25% - 20px)',
      padding: [60, 50, 15],
      // margin: 10,
      borderRadius: 15,
      boxShadow: '2px 3px 15px rgba(0, 0, 0, .07)',
      background: theme.colors[1],
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxWidth: 315,
      textAlign: 'center',
    },
    img: {
      position: 'relative',
      zIndex: 1,
      padding: [40, 20, 30],
      '& svg': {
        position: 'absolute',
        zIndex: -1,
        width: 54,
        height: 90,
        right: 0,
        top: 0,
      },
    },
    itemTitle: {
      fontSize: 16,
      color: theme.colors[0],
      marginBottom: 15,
      lineHeight: 1.25,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    list: {
      marginTop: 40,
      margin: [0, -10],
    },
    item: {
      flex: '0 0 calc(50% - 20px)',
      padding: [60, 50, 15],
      margin: [0, 10, 20],
      maxWidth: 'none',
    },
    text: {
      width: '100%',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    intro: {
      display: 'block',
    },
    list: {
      marginTop: 80,
    },

    item: {
      flex: '0 0 calc(100% - 20px)',
      padding: [40, 50, 15],
      margin: [0, 10, 20],
      maxWidth: 'none',
    },
  }

  return output
}

export default style
